import * as React from 'react';
import styled from 'styled-components';
import { Button, ButtonColorType } from '../Button';
import Modal from './Modal';
import { SvgImage } from '../SvgImage';
import { ActionModalType } from './ActionModal.types';

export const ModalHeader = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.font1};
`;

export const ActionModalText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  margin-top: 6px;
  color: ${({ theme }) => theme.colors.font1};
`;

export const ActionModalIcon = styled(SvgImage)`
  svg {
    rect[fill]:not([fill='transparent']) {
      fill: ${({ theme }) => theme.colors.secondary};
    }

    path[fill]:not([fill='transparent']) {
      fill: ${({ theme }) => theme.colors.secondary};
    }

    path[stroke]:not([stroke='transparent']) {
      stroke: ${({ theme }) => theme.colors.secondary};
    }
  }
`;

export const ActionModalButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 53px;
  margin-bottom: 16px;
  button {
    margin: 0 5px;
  }
`;

export const ActionModalImage = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;

const ActionModal = (props: ActionModalType) => {
  const {
    onHide,
    onConfirm,
    show,
    icon,
    title,
    description,
    header,
    cancelButtonId,
    confirmButtonId,
    altButton1Text,
    altButton2Text
  } = props;
  return (
    <Modal title={title} show={show} onHide={onHide}>
      {icon && (
        <ActionModalImage>
          <ActionModalIcon height="56" width="56" inAssetsPath={icon} />
        </ActionModalImage>
      )}
      <ModalHeader>{header}</ModalHeader>
      <ActionModalText>{description}</ActionModalText>
      <ActionModalButtonsWrapper>
        <Button
          colorType={ButtonColorType.WHITE}
          type="button"
          text={altButton1Text || 'Cancel'}
          onClick={() => onHide()}
          testId={cancelButtonId || 'cancel_modal_button'}
        />
        <Button
          colorType={ButtonColorType.PRIMARY}
          type="button"
          text={altButton2Text || 'Confirm'}
          onClick={() => onConfirm()}
          testId={confirmButtonId || 'confirm_modal_button'}
        />
      </ActionModalButtonsWrapper>
    </Modal>
  );
};

export default ActionModal;
